import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { AnalysisDownloadGq, AnalysisDownloadGqProps } from './../models/AnalysisDownloadGq';

export function useGetAnalysisDownloadGq(
  command: CommandGq,
  options: QueryHookOptions<DataGq, VariablesGq> = {}
) {
  const query = useCustomQuery<DataGq, VariablesGq>(gql_query, {
    ...options,
    variables: { command: command },
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getAnalysisDownload?.download,
  };
}

export const gql_query = gql`
  query GetAnalysisDownload($command: GetAnalysisDownloadCommand!) {
    projects {
      getAnalysisDownload(command: $command) {
        download {${AnalysisDownloadGqProps}}
      }
    }
  }
`;

export interface VariablesGq {
  command: CommandGq;
}

export interface CommandGq {
  projectId: number;
  downloadId: number;
}

export interface DataGq {
  readonly projects: {
    readonly getAnalysisDownload: {
      readonly download: AnalysisDownloadGq;
    };
  };
}

export interface AnalysisDownloadCommandGq extends CommandGq {}
export interface AnalysisDownloadVariablesGq extends VariablesGq {}
export interface AnalysisDownloadDataGq extends DataGq {}
export const analysisDownloadGqlQuery = gql_query;
